import {
  CustomizationDetailsAddDressing,
  CustomizationDetailsBreadToggle,
  CustomizationDetailsContainer,
  CustomizationDetailsDressingMode,
  CustomizationDetailsDressingPortion,
  CustomizationDetailsDressingPortionV2,
  CustomizationDetailsDressingsTitle,
  CustomizationDetailsDressingWeight,
  CustomizationDetailsDressingWeightV2,
  CustomizationDetailsTitle,
} from './components';

export const CustomizationDetails = {
  Container: CustomizationDetailsContainer,
  Title: CustomizationDetailsTitle,
  DressingMode: CustomizationDetailsDressingMode,
  AddDressing: CustomizationDetailsAddDressing,
  DressingsTitle: CustomizationDetailsDressingsTitle,
  DressingWeight: CustomizationDetailsDressingWeight,
  DressingWeightV2: CustomizationDetailsDressingWeightV2,
  DressingPortion: CustomizationDetailsDressingPortion,
  DressingPortionV2: CustomizationDetailsDressingPortionV2,
  BreadToggle: CustomizationDetailsBreadToggle,
};
